import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';

@Component({
    selector: 'audit-log-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class AuditLog implements OnInit {
  public logData = [];
  public ListingName;
  public loading = true;

  public displayedColumns = ['created', 'userId', 'name', 'email', 'message'];

  constructor(
    protected dialogRef: MatDialogRef<AuditLog>,
    protected Api: ApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {}

  ngOnInit() {
    this.ListingName = this.data.listingName;
    this.data.dataSource
      .readAuditLog(this.data.listingId)
      .then(({ data }) => {
        this.logData = data;
      })
      .finally(() => (this.loading = false));
  }

  formatMessage(message) {
    return message[0].toUpperCase() + message.substring(1);
  }
}
